import uniqueId from 'lodash/uniqueId';
import styled from 'styled-components';
import orderBy from 'lodash/orderBy';
import MatrixItem from '../../organisms/JobMatrix/partials/MatrixItem';
import JobMatrix from '../../organisms/JobMatrix';
import SelectBox from '../../atoms/SelectBox';
import { mq } from '~/styles/grid';
import { useIntl } from 'react-intl';

const StyledSelect = styled(SelectBox)`
  width: 50%;
  margin-bottom: 50px;

  @media (${mq.mdDown}) {
    width: 100%;
    margin-bottom: 35px;
  }
`;

/**
 * @param {ApprenticeMatrixItemProps[]} results
 * @param {boolean | undefined} [isBrand]
 * @returns {JobMatrixItem[]}
 */
const getApprenticeMatrixItems = (results = [], isBrand) => {
  const sortedResults = orderBy(results, ['description'], ['asc']);

  return sortedResults.map((result) => ({
    description: result.description,
    column: (
      <MatrixItem
        key={uniqueId()}
        introText={result.column.introText}
        blocks={result.column.blocks.map((block) => {
          const sortedLinkList = orderBy(block.linkList, ['text'], ['asc']);
          return {
            headline: block.headline,
            linkList: sortedLinkList,
          };
        })}
        isBrand={isBrand}
      />
    ),
  }));
};

/**
 * @param {ApprenticeMatrixProps} props
 * @returns {React.ReactElement} The rendered component
 */
const ApprenticeMatrix = ({ selectBoxProps, results, isBrand }) => {
  const intl = useIntl();

  intl.formatMessage({
    id: 'placeholder',
  });

  return (
    <>
      <StyledSelect
        {...selectBoxProps}
        placeholder={intl.formatMessage({
          id: 'apprMtrx.LocationPlaceholder',
        })}
      />
      <JobMatrix
        mainHeadline={intl.formatMessage({
          id: 'apprMtrx.Heading',
        })}
        items={getApprenticeMatrixItems(results, isBrand)}
      />
    </>
  );
};

export default ApprenticeMatrix;
